export default "__VITE_ASSET__1b1ce32d__"